<div class="container-fluid p-0">
    <div class="footer">
        <span class="footer-text">Copyright 2021 Mums & Midwives. All rights reserved.</span>
    </div>
</div>